module.exports = __webpack_public_path__ + "AdProLTStd-Bold.2596727985e49eb7f11a.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/AdProLTStd-Bold.ttf
// module id = ../../../../../src/assets/fonts/AdProLTStd-Bold.ttf
// module chunks = styles